import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { Container, Row, Col, Table, Alert, Badge, Dropdown } from 'react-bootstrap';
import CustomSpinner from '../../components/CustomSpinner';
import ModalConfirm from '../../components/ModalConfirm';

const STATUS_VARIANTS = {
  active: 'success',
  pending: 'warning',
  rejected: 'danger',
};

export default class AdminBusinessesView extends Component {
  static propTypes = {
    businesses: PropTypes.array,
    loadingBusinesses: PropTypes.bool,
    loadingStatusUpdate: PropTypes.bool,
    onUpdateStatus: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      pendingAction: null,
    };
  }

  openConfirm = (id, status) => {
    this.setState({ showModal: true, pendingAction: { id, status } });
  };

  cancelConfirm = () => {
    this.setState({ showModal: false, pendingAction: null });
  };

  confirmAction = () => {
    const { pendingAction } = this.state;
    if (pendingAction) {
      this.props.onUpdateStatus(pendingAction.id, pendingAction.status);
    }
    this.setState({ showModal: false, pendingAction: null });
  };

  renderItem = item => (
    <tr key={item.id}>
      <td>
        <strong>{item.businessName}</strong>
        {item.latitude == null && (
          <Badge
            variant="warning"
            className="ml-2"
            title="Location not mapped — will retry on approval"
          >
            No Location
          </Badge>
        )}
        <br />
        <small className="text-muted">{item.email}</small>
      </td>
      <td>{item.category}</td>
      <td>
        <small>{item.address}</small>
      </td>
      <td>{item.phone || '—'}</td>
      <td>
        <Badge variant={STATUS_VARIANTS[item.status] ?? 'secondary'}>
          {item.status?.toUpperCase()}
        </Badge>
      </td>
      <td>{item.createdAt ? Moment(item.createdAt).format('MM/DD/YY') : '—'}</td>
      <td>
        <Dropdown>
          <Dropdown.Toggle variant="outline-secondary" size="sm" id={`action-${item.id}`}>
            Action
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {item.status !== 'active' && (
              <Dropdown.Item onClick={() => this.openConfirm(item.id, 'active')}>
                Approve
              </Dropdown.Item>
            )}
            {item.status !== 'rejected' && (
              <Dropdown.Item
                className="text-danger"
                onClick={() => this.openConfirm(item.id, 'rejected')}
              >
                Reject
              </Dropdown.Item>
            )}
            {item.status !== 'pending' && (
              <Dropdown.Item onClick={() => this.openConfirm(item.id, 'pending')}>
                Set Pending
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );

  render() {
    const { businesses: rawBusinesses, loadingBusinesses, loadingStatusUpdate } = this.props;
    const businesses = rawBusinesses ?? [];
    const { showModal, pendingAction } = this.state;

    const actionLabel =
      pendingAction?.status === 'active'
        ? 'Approve'
        : pendingAction?.status === 'rejected'
        ? 'Reject'
        : 'Update';

    return (
      <Container className="pt-5">
        <Row>
          <Col xs={12}>
            <h1 className="h1-list">Business Accounts</h1>
          </Col>

          <Col xs={12} className="mt-4">
            {(loadingBusinesses || loadingStatusUpdate) && <CustomSpinner />}

            {!loadingBusinesses && businesses.length === 0 && (
              <Alert variant="info">No business accounts found.</Alert>
            )}

            {!loadingBusinesses && businesses.length > 0 && (
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th>Business</th>
                    <th>Category</th>
                    <th>Address</th>
                    <th>Phone</th>
                    <th>Status</th>
                    <th>Registered</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{businesses.map(item => this.renderItem(item))}</tbody>
              </Table>
            )}
          </Col>
        </Row>

        <ModalConfirm
          title={`${actionLabel} Business`}
          message={`Are you sure you want to ${actionLabel.toLowerCase()} this business?`}
          successText={actionLabel}
          show={showModal}
          onCancel={this.cancelConfirm}
          onSuccess={this.confirmAction}
        />
      </Container>
    );
  }
}
